import {
  Batch,
  BrokerAnalytics,
  CompanyAnalytics,
  ForgotPassword,
  Homepage,
  LoadFinder,
  Login,
  PredictionLoadRates,
  PredictionMarketPotential,
  PrivacyPolicy,
  Profile,
  Trends,
  Loadboard,
  TruckList,
} from "@/pages";
import { ErrorPage } from "@/components/common/errors";
import { protectedPaths, trucklistPath } from "@/routing/paths";

export const protectedRoutes = [
  {
    path: protectedPaths[0],
    component: <Homepage />,
    exact: true,
  },
  {
    path: protectedPaths[1],
    component: <PredictionLoadRates />,
    exact: true,
  },
  {
    path: protectedPaths[2],
    component: <PredictionMarketPotential />,
    exact: true,
  },
  {
    path: protectedPaths[3],
    component: <Profile />,
    exact: true,
  },
  {
    path: protectedPaths[4],
    component: <CompanyAnalytics />,
    exact: true,
  },
  {
    path: protectedPaths[5],
    component: <Trends />,
    exact: true,
  },
  {
    path: protectedPaths[6],
    component: <Loadboard />,
    exact: true,
  },
  {
    path: protectedPaths[7],
    component: <Loadboard />,
    exact: true,
  },
  {
    path: protectedPaths[8],
    component: <LoadFinder />,
    exact: true,
  },
  {
    path: protectedPaths[9],
    component: <Batch />,
    exact: true,
  },
  {
    path: protectedPaths[10],
    component: <BrokerAnalytics />,
    exact: true,
  },
  {
    path: "*",
    component: (
      <ErrorPage
        title="Page not found!"
        description="The page you're looking for can't be found. If the problem persists, you can send us the URL using the feedback button on homepage."
      />
    ),
  },
];

export const publicRoutes = [
  {
    path: "/login",
    component: <Login />,
    exact: true,
  },
  {
    path: "/forgot-password",
    component: <ForgotPassword />,
    exact: true,
  },
  {
    path: "/privacy-policy",
    component: <PrivacyPolicy />,
    exact: true,
  },
  {
    path: trucklistPath,
    component: <TruckList />,
    exact: true,
  },
];

export const allRoutes = [...publicRoutes, ...protectedRoutes];

export const homepageRoute = protectedRoutes[0].path;
